module.exports = __webpack_public_path__ + "img/PriceQuotations_WaitingForQuotes.6d582e2e.svg";